import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es6.array.iterator.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es6.promise.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es6.object.assign.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es7.promise.finally.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es6.array.iterator.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es6.promise.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es6.object.assign.js";
import "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/core-js/modules/es7.promise.finally.js";
import Vue from 'vue';
import 'normalize.css/normalize.css'; // A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "../theme/index"; // 非ElementUI按钮样式主题
ElementUI.Dialog.props.lockScroll["default"] = false;
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss'; // global css
import Utils from "./utils/url";
Vue.prototype.Utils = Utils;
import App from "./App";
import store from "./store";
import router from "./router";
import VueStorage from 'vue-ls';
import overall from "./utils/overall";
import "./utils/amap";
import "./utils/filters";
import '@/icons'; // icon
import '@/permission'; // permission control
import "./utils/rem"; // 自适应
import directive from "./directive"; // directive
import 'es6-promise/auto';
import "../src/assets/iconfont/iconfont.css";
import * as echarts from 'echarts';
import ES6Promise from 'es6-promise';
import { permission } from '@/utils/checkPermission';
Vue.prototype.$permission = permission;
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(VueStorage);
Vue.use(overall);
Vue.config.productionTip = false;
Vue.use(directive);
require('babel-polyfill');
ES6Promise.polyfill();
Vue.prototype.$bus = new Vue();
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});

/*window.addEventListener('popstate', function() {
  history.pushState(null, null, document.URL)
})*/